{
  "$id": "feature-development-policy",
  "type": "object",
  "additionalProperties": false,
  "required": ["schema_version", "stages"],
  "properties": {
    "schema_version": { "type": "string", "const": "1" },
    "merge_mode": { "type": "string", "enum": ["append"] },
    "rounds": {
      "type": "object",
      "description": "Issue #108 — per-lane build-check-fix loop round caps. Omitted lanes use the framework defaults (fast 2, graduated 3, full 5).",
      "additionalProperties": false,
      "properties": {
        "fast": { "type": "integer", "minimum": 1 },
        "graduated": { "type": "integer", "minimum": 1 },
        "full": { "type": "integer", "minimum": 1 }
      }
    },
    "stages": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "ticket_intake": { "$ref": "#/$defs/stagePolicy" },
        "planning": { "$ref": "#/$defs/stagePolicy" },
        "specification": { "$ref": "#/$defs/stagePolicy" },
        "development": { "$ref": "#/$defs/stagePolicy" },
        "review": { "$ref": "#/$defs/stagePolicy" },
        "checks": { "$ref": "#/$defs/stagePolicy" },
        "documentation_sync": { "$ref": "#/$defs/stagePolicy" },
        "delivery": { "$ref": "#/$defs/stagePolicy" }
      }
    }
  },
  "$defs": {
    "stagePolicy": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "read": {
          "type": "array",
          "items": { "type": "string" }
        },
        "instructions": {
          "type": "array",
          "items": { "type": "string" }
        },
        "required_inputs": {
          "type": "array",
          "items": { "type": "string" }
        },
        "strictness": {
          "type": "object",
          "additionalProperties": { "type": "boolean" }
        },
        "escalation": {
          "type": "object",
          "additionalProperties": {
            "type": "string",
            "enum": ["warn", "ask", "stop"]
          }
        },
        "artifacts": {
          "type": "array",
          "items": { "type": "string" }
        },
        "attribution_gate": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "pipeline": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": true
              }
            }
          }
        },
        "checks": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "use_project_profile_commands": { "type": "boolean" },
            "commands": {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "install",
                  "dev",
                  "test",
                  "test_single",
                  "lint",
                  "format",
                  "migrate",
                  "build"
                ]
              }
            },
            "shell_commands": {
              "type": "array",
              "items": { "type": "string" }
            },
            "block_on_failure": { "type": "boolean" }
          }
        },
        "module_health_rollup": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "enabled": { "type": "boolean" },
            "command": { "type": "string" },
            "escalation": {
              "type": "string",
              "enum": ["warn", "ask", "stop"]
            }
          }
        },
        "rule_compliance": {
          "type": "object",
          "description": "Rules-as-scripts gate (issue #89). Declared on the shared stagePolicy for schema simplicity, but the default policy renders it only on the `checks` stage.",
          "additionalProperties": false,
          "properties": {
            "enabled": { "type": "boolean" },
            "mode": { "type": "string", "enum": ["off", "warn", "strict"] },
            "scope": { "type": "string", "enum": ["changed-files", "whole-tree"] },
            "diff_scope": { "type": "boolean" },
            "cache_path": { "type": "string" },
            "escalation": {
              "type": "string",
              "enum": ["warn", "ask", "stop"]
            }
          }
        }
      }
    }
  }
}
